import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const RouterNav = styled.nav`
  position: fixed;
  top: 116px;
  width: calc(100% - 60px);
  z-index: 1;
  background-color: #e4e5e7;
  height: 55px;
  align-items: center;
  transition: 0.2s ease-in-out;

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  ${mediaMaxWidth.tablet} {
    width: 100%;
    margin-left: 0;

    &.downScroll {
      top: 57px;
    }
  }
`;

export const RouterList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 5px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${mediaMaxWidth.tablet} {
    height: calc(100% - 5px);
    background-color: #fff;
  }
`;

export const RouterItem = styled.li`
  display: flex;
  justify-content: center;
  padding: 5px 15px;
  font-weight: 700;
  margin: 0 10px;
  flex-direction: column;
  position: relative;

  a {
    color: #333;

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 5px;
      background: #f2008c;
      transition: width 0.2s;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet} {
        top: 7px;
        left: -5px;
      }
    }

    &:hover {
      &::after {
        width: calc(100% + 30px);

        ${mediaMaxWidth.tablet} {
          width: calc(100% + 10px);
        }
      }
    }
  }

  a.active {
    &::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 5px;
      background: #f2008c;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet} {
        width: calc(100% + 10px);
        top: 7px;
        left: -5px;
      }
    }
  }

  ${mediaMaxWidth.tablet} {
    flex: 1;
    margin: 0;
    padding: 5px 5px;
    text-align: center;
  }
`;

export const TabIcon = styled.div`
  color: #4a4a4a;

  ${mediaMinWidth.tablet} {
    display: none;
  }
`;

export const TabText = styled.div`
  ${mediaMaxWidth.tablet} {
    text-transform: uppercase;
    font-size: 0.65em;
    font-weight: 600;
    position: relative;
    top: 3px;
  }
`;
